import gql from 'graphql-tag'

const clientiEmailSearch = gql`
  query clientiEmailSearch($search: String, $limit: Int!, $offset: Int, $where: ClientiFilterInput) {
    clientiEmailSearch(search: $search, limit: $limit, offset: $offset, where: $where) {
      email
    }
  }
`

export default clientiEmailSearch



// WEBPACK FOOTER //
// ./src/graphql/queries/clientiEmailSearch.js